import { combineReducers } from 'redux';
import Auth from '../Reducers/Auth.reducer';
import Notifications from '../Reducers/Notifications.reducer';
import Reports from '../Reducers/Reports.reducer';
import Settings from '../Reducers/Settings.reducer';
import Orders from '../Reducers/Scraping-orders.reducer';
import PurchasedHistory from '../Reducers/Purchased-history.reducer';
import PurchasedHistoryNotes from '../Reducers/Purchased-history-notes.reducer';
import PurchasedHistoryDeliveryNotes from '../Reducers/Purchased-history-delivery-notes.reducer';
import PurchasedHistoryHistories from '../Reducers/Purchased-history-histories.reducer';
import Advertisements from '../Reducers/Advertisements.reducer';
import MainSections from '../Reducers/Main-sections.reducer';
import Customers from '../Reducers/Customers.reducer';
import Groups from '../Reducers/Groups.reducer';
import PromoCodes from '../Reducers/Promo-codes.reducer';
import ScrapingItems from '../Reducers/Scraping-items.reducer';
import Transactions from '../Reducers/Transactions.reducer';
import Admins from '../Reducers/Admins.reducer';
import PaymentMethods from '../Reducers/Payment-methods.reducer';
import Drivers from '../Reducers/Drivers.reducer';
import Addresses from '../Reducers/Addresses.reducer';
import Teams from '../Reducers/Teams.reducer';
import CartOffers from '../Reducers/Cart-offers.reducer';
import PaymentMethodDiscounts from '../Reducers/Payment-method-discounts.reducer';
import Watcher from '../Reducers/Watcher.reducer';
import OrderNotes from '../Reducers/Order-notes.reducer';
import OrderDeliveryNotes from '../Reducers/Order-delivery-notes.reducer';
import OrderHistories from '../Reducers/Order-histories.reducer';
import OrderActivities from '../Reducers/Order-activities.reducer';
import Home from '../Reducers/Home.reducer';
import Products from '../Reducers/Products.reducer';
import Outfits from '../Reducers/Outfits.reducer';
import Refunds from '../Reducers/Refunds.reducer';
import RefundRequests from '../Reducers/RefundRequests.reducer';
import Layouts from '../Reducers/Layouts.reducer';
import CustomerCart from '../Reducers/CustomerCart.reducer';
import Checkout from '../Reducers/Checkout.reducer';
import Warehouses from '../Reducers/Warehouses.reducer';
import Shipments from '../Reducers/Shipments.reducer';
import Categories from '../Reducers/Sections.reducer';
import Provinces from '../Reducers/Provinces.reducer';
import Cities from '../Reducers/Cities.reducer';
import Areas from '../Reducers/Areas.reducer';
import TryOnReducer from '../Reducers/TryOn.reducer';
import ScreenMessagesReducer from '../Reducers/ScreenMessages.reducer';
import OrderStateGroups from '../Reducers/Order-state-groups.reducer';
import Receiving from '../Reducers/Receiving.reducer';
import Sorting from '../Reducers/Sorting.reducer';
import Packing from '../Reducers/Packing.reducer';
import Governorates from '../Reducers/Governorates.reducer';
import Districts from '../Reducers/Districts.reducer';
import Subdistricts from '../Reducers/Subdistricts.reducer';
import CitiesV2 from '../Reducers/CitiesV2.reducer';

const selector = combineReducers({
    Auth,
    Home,
    Admins,
    Drivers,
    Notifications,
    Addresses,
    Orders,
    PurchasedHistory,
    PurchasedHistoryNotes,
    PurchasedHistoryDeliveryNotes,
    PurchasedHistoryHistories,
    OrderNotes,
    OrderDeliveryNotes,
    OrderHistories,
    OrderActivities,
    Advertisements,
    MainSections,
    Customers,
    Groups,
    PromoCodes,
    PaymentMethodDiscounts,
    ScrapingItems,
    Products,
    Outfits,
    Reports,
    Transactions,
    Settings,
    PaymentMethods,
    CartOffers,
    Teams,
    Refunds,
    RefundRequests,
    Layouts,
    CustomerCart,
    Checkout,
    Warehouses,
    Shipments,
    Categories,
    Watcher,
    Provinces,
    Cities,
    Areas,
    TryOn: TryOnReducer,
    ScreenMessagesReducer,
    OrderStateGroups,
    Receiving,
    Sorting,
    Packing,
    Governorates,
    Districts,
    Subdistricts,
    CitiesV2
});
export default selector;

export type SelectorState = ReturnType<typeof selector>